import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";

export const initState = {
    selectedCompany: {
        id: null,
        label: "",
        addressList: [{ id: null, phone1: "", phone2: "", email: "" }],
        contacts: [],
    },
    selectedContact: {
        id: null,
        name: "",
        firstName: "",
        lastName: "",
        addressList: [{ id: null, phone1: "", phone2: "", email: "" }],
        assistant: "",
        assistantPhone: "",
        assistantEmail: "",
        note: "",
        advTypes: [],
        contactRoles: [],
        pronoun:null
    },
    openCompanyForm: false,
    openContactForm: false,
    companyEditMode: false,
    contactEditMode: false,
    contactCopyMode: false,
    savingContactStatus: ACTION_STATES.NO_REQUEST,
    savingCompanyStatus: ACTION_STATES.NO_REQUEST,
    removingContactStatus: ACTION_STATES.NO_REQUEST,
    removingCompanyStatus: ACTION_STATES.NO_REQUEST,
    error: null,
    company: null,
};

export class SELECT_COMPANY extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign(
            {},
            state,
            {
                selectedCompany: payload
                    ? {
                        id: payload.value,
                        label: payload.label,
                        addressList: payload.addresses,
                        contacts: payload.contacts,
                    }
                    : { ...initState.selectedCompany },
            },
            {
                selectedContact: { ...initState.selectedContact },
            }
        );
    }
}

export class SELECT_CONTACT extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            selectedContact: {
                id: payload.id,
                name: payload.name,
                firstName: payload.firstName,
                lastName: payload.lastName,
                addressList: payload.addresses,
                assistant: payload.assistant,
                assistantPhone: payload.assistantPhone,
                assistantEmail: payload.assistantEmail,
                note: payload.note,
                title: payload.title,
                advTypes: payload.advTypes,
                contactRoles: payload.contactRoles,
                ...payload,
            },
        });
    }
}

export class SAVE_CONTACT extends ComplexAction {
    successRdx(state, { payload }) {
        const newCompany = {
            ...state.selectedCompany,
            contacts: [...state.selectedCompany.contacts.filter((contact) => contact.id !== payload.id), payload],
        };
        return Object.assign({}, state, {
            selectedCompany: newCompany,
            selectedContact: payload,
            savingContactStatus: ACTION_STATES.SUCCESS,
        });
    }

    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            savingContactStatus: ACTION_STATES.FAILED,
            error: payload.error,
        });
    }
}

export class REMOVE_CONTACT extends ComplexAction {
    successRdx(state, { payload }) {
        const newCompany = {
            ...state.selectedCompany,
            contacts: state.selectedCompany.contacts.filter((contact) => contact.id !== payload),
        };
        return Object.assign({}, state, {
            selectedCompany: newCompany,
            selectedContact: { ...initState.selectedContact },
            removingContactStatus: ACTION_STATES.SUCCESS,
        });
    }

    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            removingContactStatus: ACTION_STATES.FAILED,
            error: payload.error,
        });
    }
}

export class COPY_CONTACT extends DefaultAction {
    callRdx(state, { payload }) {
        const newAddresses = payload.addressList.map((address) => Object.assign(address, { id: null }));
        return Object.assign({}, state, {
            copiedContact: {
                name: payload.name,
                firstName: payload.firstName,
                lastName: payload.lastName,
                addressList: newAddresses,
                assistant: payload.assistant,
                assistantPhone: payload.assistantPhone,
                note: payload.note,
                title: payload.title,
                advTypes: payload.advTypes,
                contactRoles: payload.contactRoles,
                pronoun: payload.pronoun,
                assistantEmail: payload.assistantEmail
            },
            contactCopyMode: true,
        });
    }
}

export class OPEN_COMPANY_FORM extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            openCompanyForm: true,
            companyEditMode: payload,
        });
    }
}

export class OPEN_CONTACT_FORM extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            openContactForm: true,
            contactEditMode: payload,
        });
    }
}

export class CLOSE_FORM extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            openCompanyForm: false,
            openContactForm: false,
            companyEditMode: false,
            contactEditMode: false,
            contactCopyMode: false,
        });
    }
}

export class CLEAR_STATUS extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            savingContactStatus: ACTION_STATES.NO_REQUEST,
            savingCompanyStatus: ACTION_STATES.NO_REQUEST,
            removingContactStatus: ACTION_STATES.NO_REQUEST,
            removingCompanyStatus: ACTION_STATES.NO_REQUEST,
            error: null,
        });
    }
}

export class SAVE_COMPANY extends ComplexAction {
    successRdx(state, { payload }) {
        const newCompany = {
            id: payload.id,
            label: payload.name,
            addressList: [...payload.addresses],
            contacts: [...payload.contacts],
        };
        return Object.assign({}, state, {
            selectedCompany: newCompany,
            savingCompanyStatus: ACTION_STATES.SUCCESS,
        });
    }

    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            savingCompanyStatus: ACTION_STATES.FAILED,
            error: payload.error,
        });
    }
}

export class REMOVE_COMPANY extends ComplexAction {
    successRdx(state) {
        return Object.assign({}, state, {
            selectedCompany: { ...initState.selectedCompany },
            removingCompanyStatus: ACTION_STATES.SUCCESS,
        });
    }

    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            removingCompanyStatus: ACTION_STATES.FAILED,
            error: payload.error,
        });
    }
}

export class GET_COMPANY extends ComplexAction {
    successRdx(state, { payload }) {
        const newCompany = {
            id: payload.id,
            value: payload.id,
            label: payload.title,
            addressList: [...payload.addresses],
            contacts: [...payload.contacts],
        };
        return Object.assign({}, state, {
            selectedCompany: newCompany,
        });
    }

    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            error: payload.error,
        });
    }
}

export const actions = {
    SAVE_CONTACT: new SAVE_CONTACT({ loadingAtr: "savingContactStatus" }),
    REMOVE_CONTACT: new REMOVE_CONTACT({ loadingAtr: "removingContactStatus" }),
    SELECT_CONTACT: new SELECT_CONTACT(),
    COPY_CONTACT: new COPY_CONTACT(),
    SAVE_COMPANY: new SAVE_COMPANY({ loadingAtr: "savingCompanyStatus" }),
    REMOVE_COMPANY: new REMOVE_COMPANY({ loadingAtr: "REMOVE_COMPANY" }),
    SELECT_COMPANY: new SELECT_COMPANY(),
    CLEAR_STATUS: new CLEAR_STATUS(),
    OPEN_COMPANY_FORM: new OPEN_COMPANY_FORM(),
    OPEN_CONTACT_FORM: new OPEN_CONTACT_FORM(),
    CLOSE_FORM: new CLOSE_FORM(),
    GET_COMPANY: new GET_COMPANY(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
